module.exports = __webpack_public_path__ + "static/media/Nitika_1.9d022a7a.png";